import React, { createContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import RouteConstants from "../../../constants/routeConstants.json";
import {
  admiRoleListApi,
  editAdminApi,
  viewAdminDetail,
  commonRoleList
} from "../../../api/Api";
import { useCookies } from "react-cookie";
import { validateName, validateEmail } from "../../../utils/service";
import ContentData from "../../../constants/contentFile.json";

export const EditAdminContext = createContext({});
export const EditAdminContextProvider = ({ children }) => {
  const location = useLocation();
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState("");
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [successPopupMessage, setSuccessPopupMessage] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [validatedName, setValidatedName] = useState("");
  const [statusValue, setStatusValue] = useState(0);
  const [roleList, setRoleList] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [emailValidationMsg, setEmailValidationMsg] = useState("");
  const [roleCategotyValidate, setRoleCategotyValidate] = useState([]);
  const [successAlertShow, setSuccessAlertShow] = useState(false);
  const [successAlertMessage, setSuccessAlertMessage] = useState("");
  const [errorAlertShow, setErrorAlertShow] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const adminIdData = location?.state?.id;
  const navigate = useNavigate();

  const viewadmin = async (id) => {
    try {
      setSpinnerStatus(true);
      const getDetailData = await viewAdminDetail(id);
      if (getDetailData.status === 200) {
        setSpinnerStatus(false);
        console.log(getDetailData?.data?.data?.role, "1234");
        setSuccessAlertShow(false);
        setErrorAlertShow(false);
        setName(getDetailData.data.data.user?.name);
        setEmail(getDetailData.data.data.user?.email);
        setRole(getDetailData?.data?.data?.user?.role?._id);
      }
    } catch (error) {
      setSuccessAlertShow(false);

      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || ContentData.tenantPage.wentWrong;
      setStatusValue(responseStatus);

      setErrorPopupMessage(errorMessage);
      setErrorAlertShow(true);
      setStatusValue(responseStatus);

      if (responseStatus === 400) {
        setButtonText(ContentData.tenantPage.tryAgain);
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText(ContentData.tenantPage.login);
      } else {
        setButtonText(ContentData.tenantPage.tryAgain);
      }

      setSpinnerStatus(false);
    }
  };

  useEffect(() => {
    viewadmin(adminIdData);
  }, []);

  const adminToLogin = () => {
    navigate(RouteConstants.LOGIN);
    removeCookie("x-access-token");
  };
  const adminUserList = () => {
    navigate(RouteConstants.ADMIN_LIST);
  };
  // close error modal
  const onHandleClose = () => {
    setErrorPopup(false);
  };

  const roleListShown = async () => {
    try {
      const data = await commonRoleList();
      if (data?.data?.statusCode === 200) {
        setRoleList(data?.data?.data?.roleList);
      }
    } catch (error) {
      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || ContentData.tenantPage.wentWrong;
      setStatusValue(responseStatus);
      setErrorPopupMessage(errorMessage);
      setErrorAlertShow(true);
      setStatusValue(responseStatus);

      if (responseStatus === 400) {
        setButtonText(ContentData.tenantPage.tryAgain);
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText(ContentData.tenantPage.login);
      } else {
        setButtonText(ContentData.tenantPage.tryAgain);
      }
    }
  };

  const roleValidation = (value) => {
    if (value === "") {
      setRoleCategotyValidate("Select role");
      return false;
    } else {
      setRoleCategotyValidate("");
      return true;
    }
  };

  const handleRoleChange = (e) => {
    setRole(e.target.value);
    roleValidation(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleEmailBlur = () => {
    emailValidation(email);
  };

  const emailValidation = (value) => {
    if (value === "") {
      setEmailValidationMsg(ContentData.authPage.emailRequired);
      return false;
    } else if (!validateEmail(value)) {
      setEmailValidationMsg(ContentData.authPage.invalidEmail);
      return false;
    } else {
      setEmailValidationMsg("");
      return true;
    }
  };

  const nameValidation = (value) => {
    const nameRegex = /^[a-zA-Z\s]+$/;

    if (value.trim() === "") {
      setValidatedName(ContentData.adminPage.enterName);
      return false;
    } else if (!nameRegex.test(value)) {
      setValidatedName(ContentData.adminPage.validName);
      return false;
    } else {
      setValidatedName("");
      return true;
    }
  };

  const handleName = (e) => {
    setName(e.target.value);
  };

  const editAdminformValidation = async (e) => {
    e.preventDefault();
    const adminDetails = {
      name: name,
      email: email,
      role: role,
    };
    const nameValidate = nameValidation(name);
    const emailValidate = emailValidation(email);
    const roleValidate = roleValidation(role);
    if (nameValidate && emailValidate && roleValidate) {
      try {
        setSpinnerStatus(true);
        const getData = await editAdminApi(adminDetails, adminIdData);
        if (getData?.data?.statusCode === 200) {
          setErrorAlertShow(false);
          setSuccessAlertShow(true);
          setSpinnerStatus(false);
          setSuccessAlertMessage(getData?.data?.message);
        }
      } catch (error) {
        setSpinnerStatus(false);

        const responseStatus = error?.response?.data?.status;
        const errorMessage =
          error?.response?.data?.message || ContentData.tenantPage.wentWrong;
        setStatusValue(responseStatus);
        setErrorAlertMessage(errorMessage);
        setErrorAlertShow(true);
        setSuccessAlertShow(false);

        if (responseStatus === 400) {
          setButtonText(ContentData.tenantPage.tryAgain);
        } else if (responseStatus === 401 || responseStatus === 403) {
          setButtonText(ContentData.tenantPage.login);
        } else {
          setButtonText(ContentData.tenantPage.tryAgain);
        }
      }
    }
  };

  const pageToAdminView = (id) => {
    navigate(RouteConstants?.VIEW_ADMIN, {state : {id}})
  }

  const providerValue = {
    spinnerStatus,
    roleList,
    handleRoleChange,
    emailValidationMsg,
    roleCategotyValidate,
    role,
    roleListShown,
    editAdminformValidation,
    handleName,
    name,
    handleEmailChange,
    validatedName,
    email,
    adminUserList,
    successAlertMessage,

    successAlertShow,
    errorAlertMessage,
    nameValidation,
    errorAlertShow,
    setErrorAlertShow,
    spinnerStatus,
    statusValue,
    buttonText,
    adminToLogin,
    handleEmailBlur,
    nameValidation,
    viewadmin,
    adminIdData,
    pageToAdminView
  };
  return (
    <EditAdminContext.Provider value={providerValue}>
      {children}
    </EditAdminContext.Provider>
  );
};
